import { render } from "./IndexSMS.vue?vue&type=template&id=3b1f05fd"
import script from "./IndexSMS.vue?vue&type=script&lang=js"
export * from "./IndexSMS.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/helpdesk.moov-africa.bj/releases/81254874/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__